/**
 * User operations service.
 * Provides async functions for user-related operations.
 */

import { fetchApi } from "common/utils/Api";
import { User } from "model";

/**
 * Create a new user.
 */
export async function createUser(user: Partial<User>): Promise<User> {
  return fetchApi("users", {
    method: "POST",
    body: JSON.stringify(user),
  }) as Promise<User>;
}

/**
 * Change user password.
 */
export async function changePassword(
  token: string,
  newPassword: string
): Promise<{ message: string }> {
  return fetchApi("users/change-password", {
    method: "POST",
    body: JSON.stringify({ token, newPassword }),
  }) as Promise<{ message: string }>;
}

/**
 * Update a user.
 */
export async function updateUser(user: User): Promise<User> {
  return fetchApi(`users/${user.guid}`, {
    method: "PUT",
    body: JSON.stringify(user),
  }) as Promise<User>;
}
